const jwt_customizer = {
    general: 'Wystąpił błąd podczas dostosowywania tokenu JWT. Spróbuj ponownie później.',
    can_not_create_for_admin_tenant: 'Nie można utworzyć dostosowywania tokenu JWT dla administratora.',
};
export default Object.freeze(jwt_customizer);
